export default __webpack_public_path__ + "static/media/footer.0cdf0088.605a4def.webp";